import React from 'react';

interface PdfExportHostProps {
    ref?: React.Ref<HTMLDivElement>;
    children: React.ReactNode;
}

/**
 * Off-screen wrapper that the PDF capture targets. Children render at the
 * table's natural width with no overflow/scroll constraints so the capture
 * library picks up the full content (rather than the visible scroll area).
 *
 * Pair with `usePdfExport` (from `@/src/utils`) and DataTable's
 * `disablePagination` prop.
 */
export function PdfExportHost({ ref, children }: PdfExportHostProps) {
    return (
        <div
            ref={ref}
            aria-hidden="true"
            className="pdf-export-host"
            style={{
                position: 'fixed',
                left: 0,
                top: 0,
                transform: 'translateX(-200vw)',
                backgroundColor: '#fff',
                pointerEvents: 'none',
                padding: '8px',
            }}
        >
            {children}
        </div>
    );
}
